import { render, staticRenderFns } from "./MyBookmarksMfe.vue?vue&type=template&id=8964f5e0"
import script from "./MyBookmarksMfe.vue?vue&type=script&lang=js"
export * from "./MyBookmarksMfe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports